import React from 'react';
import Icon from '../../../components/AppIcon';

const KeyRisksStatus = ({ risks }) => {
  const getRiskLevelColor = (level) => {
    const colorMap = {
      'Critical': 'var(--color-error)',
      'High': 'var(--color-warning)',
      'Medium': 'var(--color-accent)',
      'Low': 'var(--color-success)'
    };
    return colorMap?.[level] || 'var(--color-muted)';
  };

  const getStatusColor = (status) => {
    const colorMap = {
      'Open': 'var(--color-error)',
      'In Progress': 'var(--color-warning)',
      'Under Review': 'var(--color-accent)',
      'Mitigated': 'var(--color-success)'
    };
    return colorMap?.[status] || 'var(--color-muted)';
  };

  return (
    <div className="space-y-4">
      {risks?.map((risk, index) => (
        <div 
          key={index}
          className="bg-card border border-border rounded-lg p-4 hover:shadow-md transition-all duration-200"
        >
          <div className="flex items-start justify-between mb-3">
            <div className="flex items-start gap-3 flex-1">
              <div 
                className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: `${getRiskLevelColor(risk?.level)}20` }}
              >
                <Icon 
                  name={risk?.icon || 'AlertTriangle'} 
                  size={20} 
                  color={getRiskLevelColor(risk?.level)} 
                />
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <h4 className="text-sm font-semibold text-foreground">{risk?.title}</h4>
                  <span 
                    className="px-2 py-0.5 rounded-full text-xs font-medium"
                    style={{ 
                      backgroundColor: `${getRiskLevelColor(risk?.level)}20`,
                      color: getRiskLevelColor(risk?.level)
                    }}
                  >
                    {risk?.level}
                  </span>
                </div>
                <p className="text-xs text-muted-foreground mb-2">{risk?.description}</p>
                <div className="flex items-center gap-4 text-xs">
                  <div className="flex items-center gap-1">
                    <Icon name="MapPin" size={12} color="var(--color-muted-foreground)" />
                    <span className="text-muted-foreground">{risk?.location}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="Calendar" size={12} color="var(--color-muted-foreground)" />
                    <span className="text-muted-foreground">{risk?.identifiedDate}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="User" size={12} color="var(--color-muted-foreground)" />
                    <span className="text-muted-foreground">{risk?.owner}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col items-end gap-2">
              <span 
                className="px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap"
                style={{ 
                  backgroundColor: `${getStatusColor(risk?.status)}20`,
                  color: getStatusColor(risk?.status)
                }}
              >
                {risk?.status}
              </span>
              {risk?.daysOpen && (
                <span className="text-xs text-muted-foreground">
                  {risk?.daysOpen} days open
                </span>
              )}
            </div>
          </div>
          
          {risk?.mitigationActions && risk?.mitigationActions?.length > 0 && (
            <div className="mt-3 pt-3 border-t border-border">
              <p className="text-xs font-medium text-foreground mb-2">Mitigation Actions:</p>
              <div className="space-y-1">
                {risk?.mitigationActions?.map((action, actionIndex) => (
                  <div key={actionIndex} className="flex items-start gap-2">
                    <Icon 
                      name={action?.completed ? 'CheckCircle2' : 'Circle'} 
                      size={14} 
                      color={action?.completed ? 'var(--color-success)' : 'var(--color-muted-foreground)'} 
                      className="mt-0.5"
                    />
                    <span className={`text-xs ${action?.completed ? 'text-muted-foreground line-through' : 'text-foreground'}`}>
                      {action?.description}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default KeyRisksStatus;